
import { Box, Button } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import SEO from '../components/SEO/SEO';
import Canvas from '../components/canvas/Canvas';
import PaintTools from '../components/paintTools/PaintTools';
import ColorTool from '../components/colorTool/ColorTool';
import { useSigilContext } from '../context/sigilContext';
import { useNavigate } from 'react-router-dom';
import SaveModal from '../components/saveModal/SaveModal';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';


import InteractiveCripto from '../components/interactiveCripto/InteractiveCripto';

const DrawBox = () => {
  const {
    criptoText,
    setOpenModal,
    savedName,
    setMessage,
    i18n
  } = useSigilContext();
  const navigate = useNavigate();
  const stageRefs = useRef([]);
  const translate = { ...i18n.drawing, ...i18n.message };

  const handleDownload = async () => {
    const uri = stageRefs.current.toDataURL();
    const base64Data = uri.split(',')[1]; // Extrae el contenido base64

    if (Capacitor.isNativePlatform()) {
      try {
        const fileName = `${savedName || 'sigilo'}.png`;
        await Filesystem.writeFile({
          path: fileName,
          data: base64Data,
          directory: Directory.Documents, // Puedes usar Directory.Data o Directory.External para Android
        });
        setMessage({
          severity: 'success',
          text: translate.export.success,
        })
      } catch (error) {
        setMessage({
          severity: 'error',
          text: translate.export.error
        })
      }
    } else {
      const link = document.createElement('a');
      link.href = uri;
      link.download = `${savedName || 'sigilo'}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    // setTimeout(() => {
    if (!criptoText) {
      navigate('/')
    }
    // }, 3000);
  }, [criptoText, navigate])

  return (
    <>
      <SEO
        title="Diseña tu Sigilo | Magia del Caos"
        description="Dibuja y personaliza tu sigilo. Utiliza nuestras herramientas de edición para crear un símbolo único."
        name="Magia del Caos"
        type="website"
      />
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        marginX: '16px',
        maxHeight: '100vh',
        flexGrow: 1
      }}>  {/* Ajuste de altura total */}
        <InteractiveCripto />
        <Box
          sx={{
            border: '1px solid white',
            borderRadius: '18px',
            display: 'flex',
            flexDirection: 'column',
            flex: 1, 
            minHeight: '300px',
            maxHeight: '70vh',
            overflow: 'hidden',
            backgroundColor: '#2C2C2C'
          }}
        >
          {/* Canvas */}
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              width: '100%',
              height: '100%'
            }}
          >
            <Canvas stageRefs={stageRefs} />
          </Box>
        </Box>

        {/* PaintTools (Ahora fuera del borde blanco y como un Dock) */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '20px',
            width: '100%'
          }}
        >
          <PaintTools stageRefs={stageRefs} />
        </Box>
        <ColorTool />
        <Box sx={{ 
          display: 'flex', 
          marginTop: '40px', 
          justifyContent: 'flex-end', 
          marginBottom: '40px', 
          alignItems: 'center',
          gap: 2
        }}>
          <Button onClick={() => navigate('/')} sx={{ color: 'white' }}> {translate.backButton} </Button>
          <Button variant='outlined' onClick={() => { setOpenModal(true) }}> {translate.saveButton} </Button>
          <Button variant='contained' onClick={() => handleDownload()}> {translate.exportButton} </Button>
        </Box>
        <SaveModal />
      </Box>
    </>
  );
}

export default DrawBox;

